import { render, staticRenderFns } from "./HomeAirControl.vue?vue&type=template&id=24da4258"
import script from "./HomeAirControl.vue?vue&type=script&lang=js"
export * from "./HomeAirControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports